export default {
    breadcrumb: {
      home: '首页',
      current: '教学',
    },
    institutions: [
      // {
      //   id: '1',
      //   title: '暨南大学',
      //   subtitle: '（主讲教师）',
      //   courses: [
      //     {
      //       id: '1',
      //       code: '无',
      //       name: '无',
      //       terms: ['无',],
      //     },
      //   ],
      // }
    ],
  };
